<!-- Start::Header -->
<header class="app-header">
  <nav class="main-header !h-[3.75rem]" aria-label="Global">
    <div class="main-header-container ps-[0.725rem] pe-[1rem] ">

      <div class="header-content-left">
        <!-- Start::header-element -->
        <div class="header-element">

          <div class="landing-logo hidden md:block absolute left-4" *ngIf="!shouldShowSidebarToggle()">
            <a routerLink="/home" class="header-logo flex items-center gap-3">
              <img src="./assets/img/toggle-logo.png" alt="logo" class="toggle-logo">
              <span class="text-[1rem] font-semibold">Nunciatura Apostólica no Brasil</span>
            </a>
          </div>

          <div class="horizontal-logo">
            <a routerLink="/home" class="header-logo">
              <img src="./assets/img/toggle-logo.png" alt="logo" class="toggle-logo">
            </a>
          </div>
        </div>
        <!-- End::header-element -->
        <!-- Start::header-element -->
        <div class="header-element md:px-[0.325rem] !items-center" *ngIf="shouldShowSidebarToggle()">
          <!-- Start::header-link -->
          <a aria-label="Hide Sidebar"
            class="sidemenu-toggle animated-arrow  hor-toggle horizontal-navtoggle inline-flex items-center"
            href="javascript:void(0);" (click)="toggleSidebar()"><span></span></a>
          <!-- End::header-link -->
        </div>
        <!-- End::header-element -->
      </div>

      <div class="header-content-right">
        <!-- Notificações -->
        <div *ngIf="isAdmin" #notificationsDropdownRoot
          class="header-element notifications-dropdown md:!px-[0.65rem] px-2 hs-dropdown !items-center ti-dropdown [--placement:bottom-left]">
          <button id="dropdown-notifications" type="button"
            class="notifications-bell-btn hs-dropdown-toggle ti-dropdown-toggle flex-shrink-0 !rounded-full !shadow-none align-middle !border-0 !shadow-transparent"
            (click)="onNotificationsDropdownOpen()"
            aria-label="Notificações">
            <i class="ri-notification-3-fill notifications-bell-icon"></i>
            <span *ngIf="unreadCount > 0" class="notifications-bell-badge">
              <span class="notifications-bell-badge__value">{{ unreadCount > 99 ? '99+' : unreadCount }}</span>
            </span>
          </button>

          <div
            class="hs-dropdown-menu ti-dropdown-menu !-mt-3 border-0 w-[22rem] !p-0 border-defaultborder hidden main-header-dropdown pt-0 overflow-hidden dropdown-menu-end"
            aria-labelledby="dropdown-notifications">
            <div class="p-3 border-b border-defaultborder/10 flex items-center justify-between">
              <p class="mb-0 font-semibold text-[0.875rem]">Notificações</p>
              <a *ngIf="unreadCount > 0" href="javascript:void(0);"
                class="text-[0.75rem] text-primary"
                (click)="onMarkAllNotificationsRead($event)">
                Marcar todas como lidas
              </a>
            </div>

            <div id="header-notification-scroll"
              class="notifications-dropdown-scroll"
              [class.is-scrollable]="notifications.length > 4">
              <div *ngIf="notifications.length === 0" class="p-4 text-center text-[0.8125rem] text-[#8c9097]">
                <i class="ri-notification-off-line text-xl mb-2 block"></i>
                Nenhuma notificação no momento
              </div>

              <ul *ngIf="notifications.length > 0" class="notifications-dropdown-list">
                <li *ngFor="let notification of notifications">
                  <a href="javascript:void(0);"
                    class="notifications-dropdown-item"
                    (click)="onNotificationClick(notification, $event)">
                    <p class="mb-1 font-semibold text-[0.8125rem] truncate">{{ notification.title }}</p>
                    <p class="mb-0 text-[0.75rem] text-[#8c9097] truncate">
                      <ng-container *ngIf="hasDetailedNotificationMessage(notification); else plainNotificationMessage">
                        O informador
                        <strong class="font-bold text-[#8c9097]">{{ notification.metadata.informer_name }}</strong>
                        respondeu o {{ notification.metadata.questionnaire_name | lowercase }} do {{ notification.metadata.group_name | lowercase }} do processo {{ notification.metadata.process_name | lowercase }} e está aguardando sua avaliação.
                      </ng-container>
                      <ng-template #plainNotificationMessage>{{ getNotificationMessageText(notification.message) }}</ng-template>
                    </p>
                    <p class="mb-0 mt-1 text-[0.6875rem] text-[#8c9097] text-end leading-tight">
                      <span class="block">{{ getNotificationDateLine(notification.created_at) }}</span>
                      <span class="block">{{ getNotificationTimeLine(notification.created_at) }}</span>
                    </p>
                  </a>
                </li>
              </ul>
            </div>

            <div class="p-2 border-t border-defaultborder/10 text-center">
              <a [routerLink]="['/admin/notifications/list']"
                class="text-[0.8125rem] text-primary font-medium"
                (click)="onViewAllNotificationsClick()">
                Ver todas as notificações
              </a>
            </div>
          </div>
        </div>

        <div *ngIf="canUseInbox"
          #inboxDropdownRoot
          class="header-element notifications-dropdown md:!px-[0.65rem] px-2 hs-dropdown !items-center ti-dropdown [--placement:bottom-left]">
          <button id="dropdown-inbox" type="button"
            class="notifications-bell-btn hs-dropdown-toggle ti-dropdown-toggle flex-shrink-0 !rounded-full !shadow-none align-middle !border-0 !shadow-transparent"
            (click)="onInboxDropdownOpen()"
            aria-label="Mensagens">
            <i class="ri-mail-fill notifications-bell-icon"></i>
            <span *ngIf="inboxUnreadCount > 0" class="notifications-bell-badge">
              <span class="notifications-bell-badge__value">{{ inboxUnreadCount > 99 ? '99+' : inboxUnreadCount }}</span>
            </span>
          </button>

          <div
            class="hs-dropdown-menu ti-dropdown-menu !-mt-3 border-0 w-[22rem] !p-0 border-defaultborder hidden main-header-dropdown pt-0 overflow-hidden dropdown-menu-end"
            aria-labelledby="dropdown-inbox">
            <div class="p-3 border-b border-defaultborder/10 flex items-center justify-between">
              <p class="mb-0 font-semibold text-[0.875rem]">Mensagens</p>
              <a routerLink="/inbox" class="text-[0.75rem] text-primary" (click)="closeInboxDropdown()">
                Abrir mensagens
              </a>
            </div>

            <div class="inbox-notifications-scroll">
              <div *ngIf="inboxNotifications.length === 0" class="p-4 text-center text-[0.8125rem] text-[#8c9097]">
                <i class="ri-mail-off-line text-xl mb-2 block"></i>
                Nenhuma mensagem no momento
              </div>

              <ul *ngIf="inboxNotifications.length > 0" class="notifications-dropdown-list">
                <li *ngFor="let notification of inboxNotifications">
                  <a href="javascript:void(0);" class="notifications-dropdown-item" (click)="onInboxNotificationClick(notification, $event)">
                    <p class="mb-1 font-semibold text-[0.8125rem] truncate">{{ notification.title }}</p>
                    <p class="mb-0 text-[0.75rem] text-[#8c9097] truncate">{{ notification.message }}</p>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div
          class="header-element md:!px-[0.65rem] px-2 hs-dropdown !items-center ti-dropdown [--placement:bottom-left]">

          <button id="dropdown-profile" type="button"
            class="hs-dropdown-toggle ti-dropdown-toggle !gap-2 !p-0 flex-shrink-0 sm:me-2 me-0 !rounded-full !shadow-none text-xs align-middle !border-0 !shadow-transparent ">
            <span class="avatar avatar-sm avatar-rounded bg-primary inline-flex items-center justify-center text-white font-semibold">
              {{ getCurrentUserDisplayName() | initials:2 }}
            </span>
          </button>
          <div class="md:block hidden dropdown-profile">
            <p class="font-semibold mb-0 leading-none text-[#536485] text-[0.813rem] ">{{ getCurrentUserDisplayName() }}</p>
            <span class="opacity-[0.7] font-normal text-[#536485] block text-[0.6875rem] ">{{ currentUser?.email || 'admin@nunciatura.com.br' }}</span>
          </div>
          <div
            class="hs-dropdown-menu ti-dropdown-menu !-mt-3 border-0 w-[11rem] !p-0 border-defaultborder hidden main-header-dropdown  pt-0 overflow-hidden header-profile-dropdown dropdown-menu-end"
            aria-labelledby="dropdown-profile">

            <ul class="text-defaulttextcolor font-medium dark:text-[#8c9097] dark:text-white/50">
              <li *ngIf="!isColaborador">
                <a class="w-full ti-dropdown-item !text-[0.8125rem] !gap-x-0  !p-[0.65rem] !inline-flex"
                  [routerLink]="getProfileLink()">
                  <i class="ti ti-user-circle text-[1.125rem] me-2 opacity-[0.7]"></i>
                  Perfil
                </a>
              </li>
              <li *ngIf="!isColaborador && !isInformador">
                <a class="w-full ti-dropdown-item !text-[0.8125rem] !gap-x-0 !p-[0.65rem] !inline-flex"
                  [routerLink]="['/admin/settings']">
                  <i class="ti ti-adjustments-horizontal text-[1.125rem] me-2 opacity-[0.7]"></i>
                  Configurações
                </a>
              </li>
              <li *ngIf="!isColaborador && !isInformador">
                <a class="w-full ti-dropdown-item !text-[0.8125rem] !p-[0.65rem] !gap-x-0 !inline-flex"
                  href="javascript:void(0);">
                  <i class="ti ti-headset text-[1.125rem] me-2 opacity-[0.7]"></i>
                  Help desk
                </a>
              </li>
              <li>
                <a class="w-full ti-dropdown-item !text-[0.8125rem] !p-[0.65rem] !gap-x-0 !inline-flex"
                   href="javascript:void(0);" (click)="onLogout()" [class.opacity-50]="loading">
                  <i class="ti ti-logout text-[1.125rem] me-2 opacity-[0.7]"></i>
                  {{ loading ? 'Saindo...' : 'Sair' }}
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </nav>
</header>